import React from 'react';
import RemoveClay from "components/ClaySizeCategory/RemoveClay/RemoveClay";
import PaletListRmPrettier from "./paletListRmPrettier";
import {useSelector} from "react-redux";

const PaletListRm = ( { category, data, onClickHandle } ) => {
  const baseUrl = useSelector(state => state.Feature.imageBaseUrl);

  // Deduplicate by color_name - show only unique colors (not each weight variant)
  const uniqueColors = data.reduce((acc, item) => {
    if (!acc.find(existing => existing.color_name === item.color_name)) {
      acc.push(item);
    }
    return acc;
  }, []);

  return (
    <div>
      <div className='acp-sm-title acp-fw-500'>{ category }</div>
      <div className='acp-colors acp-d-flex'>
        {
          uniqueColors.map((item, index) => (
            <RemoveClay key={index} id={item.id_product_attribute} src={baseUrl+item.color_medium_image} name={item.color_name} onClickHandle={() => onClickHandle(item) }/>
          ))
        }
        <PaletListRmPrettier />
      </div>
    </div>
  );
}

export default PaletListRm